import React, { useState, useEffect, useCallback } from "react";
import { ApolloClient, gql, useQuery } from "@apollo/client";
// import { GRAPHQL_AUTH_MODE } from "@aws-amplify/api";
// import { API } from "aws-amplify";
import { useMediaQuery, useTheme } from "@mui/material";

import {
  TextField,
  TextareaAutosize,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Container,
  Typography,
  Stack,
  CssBaseline,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Box,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import cache from "../../../../client/cache";
import linkForAM from "../../../../client/linkForAM";
// import { currencies } from "../../../../settings/formFieldEnum";
import { useParams, useSearchParams } from "react-router-dom";
import { offerByNumber, updateOffer } from "../query";
import { onUpdate } from "../../../../function/onUpdate";
import createNote from "../../../../function/createNote";
import getDatesDiff from "../../../../lib/getDatesDiff";
import JoeSignature from "./JoeSignature.png";

const client = new ApolloClient({
  link: linkForAM,
  cache,
  connectToDevTools: true,
});

export default function CostReviewForUnregisterdUser() {
  const params = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { entityID } = params;

  let [searchParams, setSearchParams] = useSearchParams();

  let offers = [{}];
  // const { entityID } = useParams();å
  const data = searchParams.get("data");
  let dataObj = {};
  if (data) {
    try {
      dataObj = JSON.parse(Buffer.from(data, "base64"));
    } catch (e) {
      console.log("error parsing data");
    }
  }

  const recipientName = dataObj?.recipientName;

  const { data: offerByNumberData, loading } = useQuery(gql(offerByNumber), {
    variables: {
      number: dataObj.inquiryNumber,
      // filter: { statusCode: { eq: "100" } },
    },
    skip: !dataObj.inquiryNumber,
    client,
  });

  offers = offerByNumberData?.offerByNumber?.items || [];

  offers = [...offers]?.sort((a, b) => (a.itemNumber > b.itemNumber ? 1 : -1));

  const { inquiryValidDays, createdAt } = offers?.[0] || {};

  const diff = getDatesDiff(Date.now(), createdAt);

  if (diff > inquiryValidDays)
    if (offers?.length === 0) {
      return (
        <Typography variant="h3">
          Something went wrong, please try again later
        </Typography>
      );
    }

  const vendor = offers?.[0]?.vendor;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        // bgcolor: "red",
        justifyContent: "center",
        alignContent: "center",
        display: "flex",
      }}
    >
      {/* <GlobalStyles
        styles={{ ul: { margin: 0, padding: 0, listStyle: "none" } }}
      /> */}
      <CssBaseline />
      {loading ? (
        <CircularProgress sx={{ alignSelf: "center" }} color="secondary" />
      ) : (
        <Container
          disableGutters
          // maxWidth="lg"
          component="main"
          // alignContent="center"

          sx={{
            p: 5,
            mt: 10,
            mb: 5,
            // bgcolor: "blue",
            // justifyContent: "center",
            // alignItems: "center",
          }}
        >
          <Stack spacing={10}>
            {diff > inquiryValidDays + 1 ? (
              <Typography variant="h3" color="secondary" sx={{ mt: 20 }}>
                The RFQ has expired.
              </Typography>
            ) : offers?.length === 0 ? (
              <Typography variant="h3" color="secondary" sx={{ mt: 20 }}>
                Something went wrong, please try again later
              </Typography>
            ) : offers?.length > 0 &&
              !offers.some((x) => x.statusCode === "100") ? (
              <Typography variant="h3" color="secondary" sx={{ mt: 20 }}>
                The response has been submitted, thank you!
              </Typography>
            ) : vendor?.id !== entityID ? (
              <Typography variant="h3" color="secondary" sx={{ mt: 20 }}>
                Something went wrong, please try again later
              </Typography>
            ) : (
              <>
                <div
                  dangerouslySetInnerHTML={{
                    __html: `<p>Dear ${vendor?.name},</p>
        <p>I hope this message finds you well.</p>
        <p>To remain competitive in today&rsquo;s challenging market, we are currently conducting a comprehensive cost review across our supply chain. As part of this initiative, we are reaching out to key partners like you to explore opportunities for cost savings that are essential for the continued growth of both our businesses and the success of our shared customers.</p>
        <p>We are targeting an ambitious cost reduction for the new fiscal year. We believe the cost adjustment is not only necessary to stay aligned with market conditions but also mutually beneficial as we strive for long-term, sustainable collaboration.</p>
        <p>We have identified the following materials currently being purchased from your company, we kindly request your support in reviewing these items and providing revised pricing that helps us meet our target. Achieving this cost optimization is a key part of ensuring we can continue to grow together and remain competitive in the market.</p>
        <p>Please let us know your proposed cost-saving plan or if you would like to schedule a call to discuss further.</p>
        <p>Thank you for your continued partnership and support.</p>
        <p>Best regards,<br /> Joe Tako<br /> <img src=${JoeSignature} alt="signature" width='120px'  />
  <br /> Purchasing Manager<br /> Hankeno Inc.<br /> </p>

        `,
                  }}
                />
                {isMobile ? (
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                  >
                    <Typography style={{ textDecoration: "underline" }}>
                      Material List
                    </Typography>
                    {offers.map((row) => (
                      <MobileItem
                        row={row}
                        key={row.id}
                        recipientName={recipientName}
                      />
                    ))}
                  </Box>
                ) : (
                  <TableContainer component={Paper} sx={{ minHeight: 200 }}>
                    <Table sx={{}} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>MFR</TableCell>
                          <TableCell>MPN</TableCell>
                          <TableCell className="shrink-0">EAU</TableCell>

                          {/* <TableCell>EAU</TableCell> */}
                          <TableCell width="300px">TARGET PRICE</TableCell>

                          <TableCell align="center"> ACTION</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {offers?.map((row) => (
                          <TableItem
                            row={row}
                            key={row.id}
                            recipientName={recipientName}
                          />
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </>
            )}
          </Stack>
        </Container>
      )}
    </Box>
  );
}

function TableItem({ row, recipientName }) {
  const {
    id,
    material,
    EAU,
    TP,
    TPCurrency,
    application,
    itemNumber,
    statusCode,
    price: rowPrice,
  } = row;

  const [price, setPrice] = useState(rowPrice);
  const [currency, setCurrency] = useState(TPCurrency);
  // const [hasSubmitted, setHasSubmitted] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [canMeetTargetPrice, setCanMeetTargetPrice] = useState("yes");
  const [reason, setReason] = useState("");
  // console.log({ price });
  const onSubmit = async () => {
    let newPrice = price;
    if (canMeetTargetPrice === "yes") {
      newPrice = TP;
    }

    if (!newPrice) {
      alert("Please enter new quote");
      return;
    }

    if (!canMeetTargetPrice && !reason) {
      alert("Please enter reason");
      return;
    }
    try {
      setIsloading(true);
      const fieldsToUpdate = [
        { field: "currency", createUpdate: false },
        { field: "price", createUpdate: false },
        { field: "leadtime", createUpdate: false },
        { field: "statusCode", createUpdate: false },
      ];

      await onUpdate({
        type: "Offer",
        values: { id, price: newPrice, currency, statusCode: "200" },
        mutation: updateOffer,
        // query: getOffer,
        getInitialValue: () => ({
          id,
          price: row.price,
          currency: row.currency,
          statusCode: row.statusCode,
        }),
        fieldsToUpdate,
        client,
        refetchQueries: [""],
      });

      if (reason) {
        await createNote({
          client,
          input: {
            itemID: id,
            type: "COMMENT",
            message: reason,
            createdBy: recipientName,
          },
        });
      }
      setIsloading(false);
    } catch (err) {
      console.log({ err });
    }
  };

  return (
    <TableRow
      key={row.id}
      sx={{
        "&:last-child td, &:last-child th": { border: 0 },
      }}
    >
      <TableCell component="th" scope="row">
        {material?.mfr}
      </TableCell>
      <TableCell>{material?.mpn}</TableCell>
      <TableCell className="shrink-0">{EAU?.toLocaleString()} units</TableCell>

      {/* <TableCell>{EAU}</TableCell> */}

      <TableCell>
        {TPCurrency}
        {TP}
      </TableCell>

      <TableCell>
        <Stack direction="row" justifyContent={"space-between"}>
          <Stack direction="column" spacing={2}>
            <Stack
              direction="row"
              spacing={2}
              sx={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
              }}
            >
              <Typography>Are you able to meet our target price?</Typography>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="yes"
                  name="radio-buttons-group"
                  value={canMeetTargetPrice}
                  onChange={(e) => setCanMeetTargetPrice(e.target.value)}
                >
                  <FormControlLabel
                    value={"yes"}
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Stack>
            {canMeetTargetPrice == "no" && (
              <Stack spacing={2}>
                <Stack>
                  <Typography>Reason:</Typography>
                  <TextareaAutosize
                    style={{ width: "400px" }}
                    minRows={3}
                    label="Please enter reason"
                    variant="outlined"
                    value={reason || ""}
                    onChange={(e) => setReason(e.target.value)}
                  />
                </Stack>
                <Stack>
                  <Typography>Updated Price:</Typography>
                  <TextField
                    disabled={statusCode === "200"}
                    type="number"
                    sx={{ width: 200 }}
                    // label="Please enter the updated price"
                    // variant="outlined"
                    InputProps={{ inputProps: { min: 0 } }}
                    value={price || row.price || ""}
                    onChange={(e) => setPrice(e.target.value)}
                  />
                </Stack>
              </Stack>
            )}
          </Stack>
          <LoadingButton
            loading={isLoading}
            disabled={statusCode === "200"}
            variant="contained"
            sx={{ alignSelf: "center", width: 120 }}
            onClick={onSubmit}
          >
            {statusCode === "200" ? "SUBMITTED" : "SUBMIT"}
          </LoadingButton>
        </Stack>
      </TableCell>
    </TableRow>
  );
}

function MobileItem({ row, recipientName }) {
  const {
    id,
    statusCode,
    material,
    TP,
    EAU,
    TPCurrency,
    price: rowPrice,
  } = row;

  const [price, setPrice] = useState(rowPrice);
  const [currency, setCurrency] = useState(TPCurrency);
  // const [hasSubmitted, setHasSubmitted] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [canMeetTargetPrice, setCanMeetTargetPrice] = useState("yes");
  const [reason, setReason] = useState("");

  const onSubmit = async () => {
    let newPrice = price;
    if (canMeetTargetPrice === "yes") {
      newPrice = TP;
    }

    if (!newPrice || !currency) {
      alert("Please enter price and currency");
      return;
    }
    try {
      setIsloading(true);
      const fieldsToUpdate = [
        { field: "currency", createUpdate: false },
        { field: "price", createUpdate: false },
        { field: "leadtime", createUpdate: false },
        { field: "statusCode", createUpdate: false },
      ];

      await onUpdate({
        type: "Offer",
        values: { id, price: newPrice, currency, statusCode: "200" },
        mutation: updateOffer,
        // query: getOffer,
        getInitialValue: () => ({
          id,
          price: row.price,
          currency: row.currency,
          statusCode: row.statusCode,
        }),
        fieldsToUpdate,
        client,
        refetchQueries: [""],
      });

      if (reason) {
        await createNote({
          client,
          input: {
            itemID: id,
            type: "COMMENT",
            message: reason,
            createdBy: recipientName,
          },
        });
      }
      setIsloading(false);
    } catch (err) {
      console.log({ err });
    }
  };

  return (
    <Paper key={row.id} sx={{ p: 2 }}>
      <Typography variant="body2">
        <strong>MFR:</strong> {material.mfr}
      </Typography>
      <Typography variant="body2">
        <strong>MPN:</strong> {material.mpn}
      </Typography>
      <Typography variant="body2">
        <strong>EAU:</strong>
        {EAU?.toLocaleString()} units
      </Typography>
      <Typography variant="body2">
        <strong>TARGET PRICE:</strong> {TPCurrency}
        {TP}
      </Typography>

      <Typography variant="body2">
        <strong>Are you able to meet our target price?</strong>{" "}
      </Typography>
      <Stack spacing={2}>
        <Stack direction="column" spacing={2}>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
            }}
          >
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="yes"
                name="radio-buttons-group"
                value={canMeetTargetPrice}
                onChange={(e) => setCanMeetTargetPrice(e.target.value)}
              >
                <FormControlLabel
                  value={"yes"}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel value="no" control={<Radio />} label="no" />
              </RadioGroup>
            </FormControl>
          </Stack>
          {canMeetTargetPrice == "no" && (
            <Stack spacing={2}>
              <Stack>
                <Typography>Reason:</Typography>
                <TextareaAutosize
                  style={{ width: "400px" }}
                  minRows={3}
                  label="Please enter reason"
                  variant="outlined"
                  value={reason || ""}
                  onChange={(e) => setReason(e.target.value)}
                />
              </Stack>
              <Stack>
                <Typography>Updated Price:</Typography>
                <TextField
                  disabled={statusCode === "200"}
                  type="number"
                  sx={{ width: 200 }}
                  // label="Please enter the updated price"
                  // variant="outlined"
                  InputProps={{ inputProps: { min: 0 } }}
                  value={price || row.price || ""}
                  onChange={(e) => setPrice(e.target.value)}
                />
              </Stack>
            </Stack>
          )}
        </Stack>
        <LoadingButton
          loading={isLoading}
          disabled={statusCode === "200"}
          variant="contained"
          sx={{ alignSelf: "center", width: 120 }}
          onClick={onSubmit}
        >
          {statusCode === "200" ? "SUBMITTED" : "SUBMIT"}
        </LoadingButton>
      </Stack>
    </Paper>
  );
}
